var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdviser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4863 9.74689C23.6019 9.73655 23.7174 9.71933 23.8366 9.71933C25.5844 9.71933 26.9999 10.8458 26.9999 12.2342V14.5251C26.9999 15.9135 25.5844 17.04 23.8366 17.04C23.7174 17.04 23.4863 17.0124 23.4863 17.0124",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4863 9.74689C23.6019 9.73655 23.7174 9.71933 23.8366 9.71933C25.5844 9.71933 26.9999 10.8458 26.9999 12.2342V14.5251C26.9999 15.9135 25.5844 17.04 23.8366 17.04C23.7174 17.04 23.4863 17.0124 23.4863 17.0124",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51361 9.74689C4.39806 9.73655 4.2825 9.71933 4.16333 9.71933C2.41556 9.71933 1 10.8458 1 12.2342V14.5251C1 15.9135 2.41556 17.04 4.16333 17.04C4.2825 17.04 4.39806 17.0228 4.51361 17.0124L5.05528 16.9401",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51361 9.74689C4.39806 9.73655 4.2825 9.71933 4.16333 9.71933C2.41556 9.71933 1 10.8458 1 12.2342V14.5251C1 15.9135 2.41556 17.04 4.16333 17.04C4.2825 17.04 4.39806 17.0228 4.51361 17.0124L5.05528 16.9401",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.568 22.0628C18.568 22.9895 17.7808 23.7405 16.813 23.7405H11.8946C10.9233 23.7405 10.1396 22.9895 10.1396 22.0628C10.1396 21.1361 10.9269 20.3885 11.8946 20.3885H16.813C17.7844 20.3885 18.568 21.1396 18.568 22.0628Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5442 20.9914C7.13534 20.5298 4.51367 17.7324 4.51367 14.3529V7.70399C4.51367 4.0006 7.65895 1 11.5409 1H16.4592C20.3412 1 23.4864 4.0006 23.4864 7.70399V17.0331",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7554 7.9176V8.95111",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9666 7.9176V8.95111",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81836 13.8706C10.2409 15.1969 12.0861 16.196 14.2997 16.196C16.5134 16.196 18.3586 15.1969 18.7811 13.8706",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdviser);
export default __webpack_public_path__ + "static/media/icon_adviser.1f64055e4b3cfe0711557cea3186560d.svg";
export { ForwardRef as ReactComponent };